// Polite "temporarily unavailable" notice (ServiceNotice) and the WhatsApp fallback of the checkout.
export default {
  notice: {
    "title": "Service temporarily unavailable",
    "message": "{{what}} is not working at the moment. We kindly ask you to contact us on WhatsApp to confirm your booking — our team replies quickly.",
    "whatsapp": "Confirm on WhatsApp",
    "retry": "Try again",
    "hint": "We apologize for the inconvenience.",
    "what": {
      "payment": "Online payment",
      "booking": "Online booking for this date",
      "seats": "Online booking for this tour",
      "tour": "This tour page",
      "page": "This page",
      "generic": "This service"
    },
    "fallback": {
      "title": "Confirm your booking on WhatsApp",
      "preflight": "Online payment by Pix is not available at the moment. So you don’t lose your spot, confirm the booking directly with our team on WhatsApp — we send all the details for you.",
      "failed": "We couldn’t complete the online payment right now. To secure your spot, confirm the booking directly with our team on WhatsApp — we send all the details for you.",
      "point1": "Tour, date and guests are already in the message",
      "point2": "Our team confirms availability and payment with you",
      "point3": "Your booking is saved with a reference code",
      "cta": "Confirm booking on WhatsApp",
      "autoOpening_one": "Opening WhatsApp in {{count}} second…",
      "autoOpening_other": "Opening WhatsApp in {{count}} seconds…",
      "stay": "I’d rather stay here",
      "autoCancelled": "Automatic opening cancelled. Use the button below whenever you like.",
      "retryOnline": "Try online payment again"
    }
  },
};
